module.exports = __webpack_public_path__ + "static/media/autum-stream.35799726.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/autum-stream.jpg
// module id = 37
// module chunks = 0